import { z } from "zod";
import { type Price, priceZodSchema } from "../../prices/price";
import { type ProviderId, providerIdZodSchema } from "../provider-id";

type ProviderSetDeliveryOrderMinLimitCommand = {
    _type: "PROVIDER_SET_DELIVERY_ORDER_MIN_LIMIT_COMMAND";
    providerId: ProviderId;
    limit: Price;
};

const providerSetDeliveryOrderMinLimitCommandZodSchema: z.ZodSchema<ProviderSetDeliveryOrderMinLimitCommand> =
    z.object({
        _type: z.literal("PROVIDER_SET_DELIVERY_ORDER_MIN_LIMIT_COMMAND"),
        providerId: providerIdZodSchema,
        limit: priceZodSchema,
    });

export { providerSetDeliveryOrderMinLimitCommandZodSchema };
export type { ProviderSetDeliveryOrderMinLimitCommand };
